import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const CloseIconButton = styled(IconButton)`
  position: absolute;
  right: 16px;
  top: 8px;
  z-index: 999;
`

type HelpDialogProps = {
  open: boolean;
  onClose: () => void;
  titleValue?: string;
  contentValue?: string;
}
export type HelpActionType = Omit<HelpDialogProps, 'onClose'>
const HelpDialog: React.FC<HelpDialogProps> = ({ open, onClose, titleValue, contentValue }) => {
  const [content, setContent] = useState('');

  const getContent = async () => {
    if (!contentValue) return;
    const dangerouslyHtml = await marked.parse(contentValue);
    const clean = DOMPurify.sanitize(dangerouslyHtml, { USE_PROFILES: { html: true } });
    setContent(clean);
  }

  useEffect(() => {
    getContent();
  }, [contentValue])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{ titleValue }</DialogTitle>
      <CloseIconButton onClick={onClose}><CloseIcon /></CloseIconButton>
      <DialogContent><Typography variant="body1"><div dangerouslySetInnerHTML={{ __html: content }} /></Typography></DialogContent>
    </Dialog>
  );
}

export default HelpDialog;
